import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import TopNav from './TopNav';
import SideNav from '../../sideNav';
import Hero from './hero';
import ValueProps from 'scy/ValueProps';
import MediaLogos from 'scy/MediaLogos';
import FAQ from './faq';
import Categories from './categories';
import Testimonials from './Testimonials';
import Territories from './Territories';
import Footer from '../../footer';
import AsyncLeadCaptureModal from 'components/leadCaptureModal/async';
import { track } from 'shared/models/analytic';
import { borderBox, textCenter } from 'scy/utils.mod.scss';
import { MutedBackground } from 'scy/Background';
import { WideContainer } from 'scy/layouts';
import { H2Alt } from 'scy/text';
import padding from 'scy/padding.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';
import { slideoutPanel } from '../../sideNav/styles.mod.scss';

export default function HomeLandingPage() {
  useEffect(() => {
    track('Landing Page Viewed');
  }, []);

  const valuePropsId = 'value-props';

  const panelRef = useRef();
  const toggleRef = useRef();

  return (
    <div className={borderBox}>
      <main ref={panelRef} className={slideoutPanel}>
        <TopNav valuePropsId={valuePropsId} toggleRef={toggleRef} />
        <Hero />
        <ValueProps id={valuePropsId} />

        <MutedBackground className={styles.logoBg}>
          <WideContainer
            tag="section"
            className={classnames(
              padding.top_md,
              padding.bottom_md,
              padding.tablet_top_lg,
              padding.tablet_bottom_lg
            )}
          >
            <MediaLogos />
          </WideContainer>

          <WideContainer tag="section">
            <Categories />
          </WideContainer>

          <WideContainer
            tag="section"
            className={classnames(
              padding.top_md,
              padding.bottom_md,
              padding.tablet_top_xl,
              padding.tablet_bottom_xl,
              textCenter
            )}
          >
            <H2Alt
              marginClass={classnames(
                margin.top_md,
                margin.bottom_md,
                margin.tablet_bottom_lg
              )}
            >
              People Love Us
            </H2Alt>
            <Testimonials />
          </WideContainer>
        </MutedBackground>

        <Territories />
        <FAQ />
        <Footer />
        <AsyncLeadCaptureModal />
      </main>

      <SideNav panelRef={panelRef} toggleRef={toggleRef} />
    </div>
  );
}
